export default __webpack_public_path__ + "static/media/poster-hero-villain.9cedfdce.png";